import { text } from "./text.i18n";
import { validation } from "./validation.i18n";

/**
 * Language resources for the application.
 * @typedef {Object} LanguageResources
 * @property {Object} text - Text resources for the application.
 * @property {Object} validation - Validation messages for the application.
 */
export const appLanguage = { text, validation };
